import { render } from "./MemoruAlbum.vue?vue&type=template&id=6abaf3a4&ts=true"
import script from "./MemoruAlbum.vue?vue&type=script&lang=ts"
export * from "./MemoruAlbum.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__